import React from 'react';
import { Notification, moment } from 'omni-common-ui';
import NotificationCalloutSlide from 'containers/NotificationCalloutSlide';
import { isUnitReport, isProgressReport } from './accessors';

const reviveCommonNotification = ({ noteId, studentName, category, notedDateTimeUtc, dosName }) => {
  let blurb = `${studentName} has a new ${category} note`;
  if (isUnitReport(category)) {
    blurb = `Note from ${dosName}: Problem with Unit Report (depending what is rejected)`;
  } else if (isProgressReport(category)) {
    blurb = `Note from ${dosName}: Problem with Progress Report (depending what is rejected)`;
  }

  return {
    blurb,
    moment: moment.utc(notedDateTimeUtc),
    getNotificationViewNode: (tray) =>
      <NotificationCalloutSlide noteId={`${noteId}`}
          category={category}
          notificationsTray={tray} />,
  };
};

const create = (data) =>
  Notification.create(reviveCommonNotification(data));

export default create;



// WEBPACK FOOTER //
// ./data/Users/Notifications/create.jsx